import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip as UiTooltip } from '@/ui';
import { COLORS } from '@/theme';

interface IInfoLabelProps {
  label: string;
  tooltip: string;
}

const InfoLabel = ({ label, tooltip }: IInfoLabelProps) => (
  <>
    {label}
    <UiTooltip title={tooltip}>
      <InfoCircleOutlined
        style={{
          marginLeft: 6,
          color: COLORS.GRAY_PRIMARY,
          cursor: 'help',
        }}
      />
    </UiTooltip>
  </>
);

export default InfoLabel;
